import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the sessions, in one place: PageService and the page take them from here. */
class SessionsIconsClass {
    public readonly DeleteOlder: IconType = Icons.CalendarX2;
    public readonly DeleteWithoutUser: IconType = Icons.UserX;
    public readonly Session: IconType = Icons.MonitorSmartphone;
}

export const SessionsIcons = new SessionsIconsClass();
